import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Component, Inject, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { MatchEvent, Match, ClipData } from '../../../models';
import { Router } from '@angular/router';

@Component({
  selector: 'clip-viewer-dialog',
  templateUrl: './clip-viewer-dialog.html',
  styleUrls: ['./clip-viewer-dialog.css']
})
export class ClipViewerDialogComponent implements OnInit {
  match: Match;
  clips: MatchEvent[];
  displayName: string;
  playlistId?: string;

  constructor(
    private router: Router,
    public dialogRef: MatDialogRef<ClipViewerDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ClipData
  ) {}

  ngOnInit(): void {

    console.info('[ClipViewerDialog] init: ', this.data);
    this.match = this.data.match;
    this.clips = this.data.clips;
    this.displayName = this.data.name;
    this.playlistId = this.data.playlistId;


  }

  onCloseClipViewer() {
    this.dialogRef.close();
  }

  onSharePlaylist() {
    this.dialogRef.close();
    this.router.navigate(['/playlist', this.playlistId]);
  }
}
